import api from "../../api/apiInterceptor";

export function fetchAllTriggersPaggination(installationId, page, pageSize) {
    return api.get(`api/installations/${installationId}/triggers?page=${page}&size=${pageSize}`)
}

export function createTrigger(installationId,data) {
    return api.post(`api/installations/${installationId}/triggers`,data)
}

export function updateTriggerUrl(installationId,triggerItemId,data) {
    return api.put(`api/installations/${installationId}/triggers/${triggerItemId}`,data)
}

export function deleteTriggerUrl(installationId,triggerItemId) {
    return api.delete(`api/installations/${installationId}/triggers/${triggerItemId}`)
}

export function fetchAllInstructionsPaggination(installationId, triggerItemId, page, pageSize) {
    return api.get(`/api/installations/${installationId}/triggers/${triggerItemId}/instructions?page=${page}&size=${pageSize}`)
}

export function deleteInstructionUrl(installationId, triggerItemId, idForDelete) {
    return api.delete(`/api/installations/${installationId}/triggers/${triggerItemId}/instructions/${idForDelete}`)
}